
  import { Component, Vue } from 'vue-property-decorator';
  import ChangePasswordPopup from '@/modules/Profile/components/popups/ChangePasswordPopup.vue';
  import ChangeEmailPopup from '@/modules/Profile/components/popups/ChangeEmailPopup.vue';
  import AppPageHeader from "@/components/AppPageHeader.vue";
  import ProfileTabs from "@/modules/Profile/components/ProfileTabs.vue";
  import LoginSelectCorpPopup from "@/modules/Auth/components/LoginSelectCorpPopup.vue";
  import {IAppState} from "@/interfaces/app-state.interface";
  import {IDialogStoreState} from "@/modules/Popup/interfaces/dialog.interface";
  import FavoriteCarsPopup from "@/modules/Home/components/popups/FavoriteCarsPopup.vue";

  @Component({
    components: {
      FavoriteCarsPopup,
      LoginSelectCorpPopup,
      ProfileTabs,
      ChangePasswordPopup,
      ChangeEmailPopup,
      AppPageHeader,
    },
  })

  export default class ThePageProfile extends Vue {
    isLoading: boolean = true;

    get storeState(): IAppState { return this.$store.state; }
    get popups(): IDialogStoreState { return this.storeState.dialog; }
    get refMode() { return this.storeState.profile.refMode; }

    async created () {
      try {
        await this.$store.dispatch('auth/init');
        await this.$store.dispatch("book/initBooksForPage", this.$route.name);
        await this.$store.dispatch('profile/init');
        await this.$store.dispatch('initialized');
        this.isLoading = false;
      }
      catch (error) {
        await this.$store.dispatch('handleError', error);
      }
    }
  }
